module.exports = __webpack_public_path__ + "static/img/wulianwang.3d908fc8.png";